import React from 'react';
import SoftChip from './SoftChip';

// Store chips shared by the store pages and the organization chart.
const STATUS_COLOR = { active: 'success', inactive: 'default', deleted: 'error' };
const COMPANY_TYPE_COLOR = { independent: 'default', headquarters: 'primary', branch: 'info' };

export const businessStatus = (business) => {
  if (business.is_deleted) return 'deleted';
  return business.is_active ? 'active' : 'inactive';
};

export function BusinessStatusChip({ t, business, sx }) {
  const status = businessStatus(business);
  return <SoftChip size="small" label={t(`businesses.statuses.${status}`)} color={STATUS_COLOR[status]} sx={sx} />;
}

export function CompanyTypeChip({ t, companyType, sx }) {
  if (!companyType) return null;
  return (
    <SoftChip
      size="small"
      label={t(`businesses.companyTypes.${companyType}`)}
      color={COMPANY_TYPE_COLOR[companyType]}
      sx={sx}
    />
  );
}
